import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import styles from "./styles.scss";

function PlanzoneKnowledge(props: Props) {
  const { t } = useTranslation();

  return (
    <a
      href="https://kc6.planzone.com/hc/fr"
      className={styles.planzoneKnowledge}
      target="_blank"
    >
      {t("common.planzoneKnowledge")}
    </a>
  );
}

export { PlanzoneKnowledge };
